import {
  CourseTypes,
  DurationTypes,
  ModalityTypes,
  PriceTypes,
} from '@/models/catalog/course';
import { ResourceTypes } from '@/models/resources';

export const videos = [
  {
    uuid: '61a1c60f-3334-5dfb-9115-a86930d00561',
    revisioned_title:
      'IA, Aprendizado de Máquina, Deep Learning e IA Generativa Explicados',
    video_url: 'https://www.youtube.com/watch?v=qYNweeDHiyU',
    thumbnail_url: 'https://i.ytimg.com/vi/qYNweeDHiyU/maxresdefault.jpg',
    channel_title: 'IBM Technology',
    duration_in_seconds: 1100,
  },
  {
    uuid: '1ef128b4-777f-50b0-9f37-86450d72cf4d',
    revisioned_title:
      'Como a IA poderia empoderar qualquer negócio | Andrew Ng | TED',
    video_url: 'https://www.youtube.com/watch?v=reUZRyXxUs4',
    thumbnail_url: 'https://i.ytimg.com/vi/reUZRyXxUs4/maxresdefault.jpg',
    channel_title: 'TED',
    duration_in_seconds: 677,
  },
  {
    uuid: '8e0b55a2-c82b-5c3b-9583-984f87ccf83e',
    revisioned_title:
      'Amor, Confiança e Marketing na Era da IA | Amaryllis Liampoti | TED',
    video_url: 'https://www.youtube.com/watch?v=4GpNYaDkBcs',
    thumbnail_url: 'https://i.ytimg.com/vi/4GpNYaDkBcs/maxresdefault.jpg',
    channel_title: 'TED',
    duration_in_seconds: 550,
  },
];

export const courses = [
  {
    id: 159082,
    offer_id: 73270281,
    offer_period: 'flex',
    offer_state: 'BR',
    offer_city: 'Nacional',
    offer_hub: 11211,
    hash_key:
      '7b8c43031894cfa380df3bbc48f061de3b3dc28978b269fde02e0493b3bb563e',
    offers_quantity: 1,
    institution: {
      id: 282,
      name: 'EBAC - Escola Britânica de Artes Criativas & Tecnologia',
      logo_url:
        'https://staging-assets.galena.com/edupass-api/public/logos/5939493d-52f1-49ce-a36f-1f91e1e06a8b.png',
      logo_background_color: '#000000',
    },
    course_name: 'Inteligência Artificial para Negócios',
    course_type: {
      type: CourseTypes.NonDegree,
      label: 'Cursos Livres',
    },
    duration: {
      type: DurationTypes.Month,
      quantity: 2,
    },
    discount_percentage: 55,
    price_with_discount: 129.37,
    original_price: 3450,
    price_type: PriceTypes.Installments,
    installments: 12,
    modalities: [
      {
        type: ModalityTypes.Online,
        label: 'Online',
      },
    ],
  },
  {
    id: 191025,
    offer_id: 68535664,
    offer_period: 'flex',
    offer_state: 'BR',
    offer_city: 'Nacional',
    offer_hub: 114861,
    hash_key:
      'ce7dd54750a21bfec63d96f2822bad1b229544ffa9ec0dd4313d3d8df758f8cf',
    offers_quantity: 1,
    institution: {
      id: 249,
      name: 'Conquer',
      logo_url:
        'https://staging-assets.galena.com/edupass-api/public/logos/742da080-0f97-4015-bcd1-329840f84311.png',
      logo_background_color: '#000000',
    },
    course_name:
      'Apresentações que conquistam: segredos da influência e persuasão + assinatura CONQUER PLUS',
    course_type: {
      type: CourseTypes.Undergraduate,
      label: 'Graduação',
    },
    duration: {
      type: DurationTypes.Year,
      quantity: 1,
    },
    discount_percentage: 56,
    price_with_discount: 100.76,
    original_price: 2748,
    price_type: PriceTypes.Installments,
    installments: 12,
    modalities: [
      {
        type: ModalityTypes.Online,
        label: 'Online',
      },
    ],
    avg_score: -0.07599740982055664,
  },
  {
    id: 118262,
    offer_id: 54898013,
    offer_period: 'flex',
    offer_state: 'BR',
    offer_city: 'Nacional',
    offer_hub: 47945,
    hash_key:
      '97e881b52f7fa90024e427db5af50334834e1ed9fffdd620ba3e8731f646a944',
    offers_quantity: 2,
    institution: {
      id: 100,
      name: 'Trevisan Escola de Negócios',
      logo_url:
        'https://staging-assets.galena.com/edupass-api/public/logos/35d9f144-ed31-4133-b5bd-d598d341f9f0.png',
      logo_background_color: '#000A2E',
    },
    course_name: 'Inteligência Artificial, Machine Learning e Deep Learning',
    course_type: {
      type: CourseTypes.Technical,
      label: 'Técnicos',
    },
    duration: {
      type: DurationTypes.Month,
      quantity: 3,
    },
    discount_percentage: 5,
    price_with_discount: 156.75,
    original_price: 495,
    price_type: PriceTypes.Installments,
    installments: 3,
    modalities: [
      {
        type: ModalityTypes.Online,
        label: 'Online',
      },
    ],
  },
  {
    id: 186244,
    offer_id: 63972496,
    offer_period: 'flex',
    offer_state: 'BR',
    offer_city: 'Nacional',
    offer_hub: 48098,
    hash_key:
      '0089c056698ef5890e8aac2c844a0f79e809f93e6b3b701bee9241c1794a419b',
    offers_quantity: 1,
    institution: {
      id: 60,
      name: 'Faculdade Alphaville',
      logo_url:
        'https://staging-assets.galena.com/edupass-api/public/logos/205d5e00-dc32-455d-bd42-e9ffa8fa612f.png',
      logo_background_color: '#105373',
    },
    course_name: 'Docência Do Ensino',
    course_type: {
      type: CourseTypes.Postgraduate,
      label: 'Pós-graduação',
    },
    duration: {
      type: DurationTypes.Month,
      quantity: 12,
    },
    discount_percentage: 63.67,
    price_with_discount: 119.67,
    original_price: 1976.4,
    price_type: PriceTypes.Installments,
    installments: 6,
    modalities: [
      {
        type: ModalityTypes.Online,
        label: 'Online',
      },
    ],
    avg_score: -0.07599740982055664,
  },
];

export const resources = [
  {
    course: {
      id: '2927d1a9-47ff-44a0-a6d9-2497240818cc',
      company_id: null,
      name: 'Especialização em Fundamentos de IA do Google',
      institution_name: 'Coursera',
      institution_id: 385,
      workload: null,
      duration: undefined,
      duration_type: undefined,
      course_type: CourseTypes.NonDegree,
      modality: ModalityTypes.Online,
      period: null,
      source: 'internal_catalog',
      price: '0.00',
      external_course_url: 'https://staging-assets.galena.com/cursos/192713',
      campus_name: null,
      campus_address_state: null,
      campus_address_city: null,
      external_course_id: '192713',
      external_offer_id: null,
      external_institution_logo_url:
        'https://assets.galena.com/edupass-api/public/logos/cf0c68df-ebb1-46c3-be32-a176517075b3.png',
      external_institution_background_color: '#0056D2',
    },
  },
  {
    external_link: {
      id: '541ace14-64a9-4bcd-b2a3-a8d410118728',
      name: 'Recurso externo - livro',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.Book,
      source: null,
    },
  },
  {
    external_link: {
      id: '3029b07e-f9d7-44d3-8f86-13e36273e78f',
      name: 'Recurso externo - curso',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.Course,
      source: null,
    },
  },
  {
    course: {
      id: '50d1fdfa-03c4-4ae6-98b5-1150c7a7e9b8',
      company_id: 'a4924238-7968-4c44-8b2a-e4d5ca2b62c3',
      name: 'Inglês Self-Study',
      institution_name: 'English Central',
      institution_id: 252,
      workload: null,
      duration: 12,
      duration_type: DurationTypes.Month,
      course_type: CourseTypes.Languages,
      modality: ModalityTypes.Online,
      period: 'flex',
      source: 'internal_catalog',
      price: '0.00',
      external_course_url: 'https://staging-assets.galena.com/cursos/100470',
      campus_name: null,
      campus_address_state: 'BR',
      campus_address_city: 'Nacional',
      external_course_id: '100470',
      external_offer_id: '520550',
      external_institution_logo_url:
        'https://assets.galena.com/edupass-api/public/logos/d46bc6a8-2f5b-4802-99da-d406b79753f5.png',
      external_institution_background_color: '#9C232A',
    },
  },
  {
    external_link: {
      id: 'fd3e941c-9747-44eb-b51d-2c85492f6268',
      name: 'Recurso externo - video',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.Video,
      source: null,
    },
  },
  {
    external_link: {
      id: 'be5a8daf-7128-4b2a-8659-b9a674412b09',
      name: 'Recurso externo - podcast',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.Podcast,
      source: null,
    },
  },
  {
    external_link: {
      id: 'd203f881-efba-45db-8cda-8660d85e39de',
      name: 'Recurso externo - evento ou palestra',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.EventOrLecture,
      source: null,
    },
  },
  {
    external_link: {
      id: 'f37a5c32-5a68-4b2d-aa0a-9e6638409043',
      name: 'Recurso externo - docs',
      description: null,
      url: 'https://docs.google.com/document/d/1qxo6_MACs-IChLnTa_XLS7l4dq0ejbcyLA5OQUcN0Ao/edit?tab=t.0#heading=h.wrpebo2m6niq',
      category: ResourceTypes.Document,
      source: null,
    },
  },
];
